import { makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles({
  root: {
    height: "10px",
    width: "10px",
    backgroundColor: props => {
      if (
        props?.status?.toLowerCase() === props?.t("client.inactive")?.toLowerCase() ||
        props?.status?.toLowerCase() === "offline" ||
        props?.status?.toLowerCase() === props?.t("requests.declined")?.toLowerCase() ||
        props?.status?.toLowerCase() === "failed" ||
        props?.status?.toLowerCase() === "rejected" ||
        props?.status?.toLowerCase() === "expired" ||
        props?.status?.toLowerCase() === "cancelled"
      ) {
        return "#E22134"
      } else if (
        props?.status?.toLowerCase() === props?.t("client.active")?.toLowerCase() ||
        props?.status?.toLowerCase() === props?.t("requests.approved")?.toLowerCase() ||
        props?.status?.toLowerCase() === "available" ||
        props?.status?.toLowerCase() === "verified" ||
        props?.status?.toLowerCase() === "success"
      ) {
        return "#1DB954"
      } else if (
        props?.status?.toLowerCase() === props?.t("requests.pending")?.toLowerCase() ||
        props?.status?.toLowerCase() === "idle" ||
        props?.status?.toLowerCase() === props?.t("requests.on_hold")?.toLowerCase() ||
        props?.status?.toLowerCase() === "processing"
      ) {
        return "#FF9800"
      } else if (
        props?.status?.toLowerCase() === "scheduled" ||
        props?.status?.toLowerCase() === "in_progress" ||
        props?.status?.toLowerCase() === "in progress" ||
        props?.status?.toLowerCase() === "waiting for approval"
      ) {
        return "#1EAAC4"
      } else if (
        props?.status?.toLowerCase() === "completed"
      ) {
        return "#1DB954"
      }
    },
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "5px"
  },
  text: {
    fontFamily: "'DM Sans', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 13,
  }
})

const NCTableStatus = props => {
  const { t } = useTranslation();
  const cls = useStyles({...props,t})
  return (
    <>
      <div className={cls.root} />
      <span className={cls.text}>{props.status}</span>
    </>
  )
}

export default NCTableStatus
